/* eslint-disable */
import { saveAs } from 'file-saver'
import { useIntl } from 'react-intl'

export const useHandleZip = () => {

  const intl = useIntl()
  const JSzip = require('jszip')
  const zip = new JSzip()

  const getDate = new Date().toLocaleDateString('en-GB').replaceAll('/', '_')

  const downloadZip = (data, fileName, noIntl) => {
    const createColumnsForCsv = (data) => {
      const uniqueKeys = Object.keys(data.reduce(function(res, obj) {
        return Object.assign(res, obj)
      }, {}))
      const mapped = uniqueKeys.map((item) => {
        return noIntl ? item : intl.formatMessage({id: item})
      })
      return mapped
    }
  
    const createRowsForCsv = (data) => {
      return data.map((item) => {
        return Object.values(item).map((formattedItem) => {
          return typeof formattedItem === 'object' && formattedItem !== null ? formattedItem.join(' / ') : JSON.stringify(formattedItem).replace('null', '')
        })
      })
    }
  
    const inputData = (data) => {
      const outputData = [
        createColumnsForCsv(data),
        ...createRowsForCsv(data)
      ]
        .map((e) => {
          return e.join(',')
        })
        .join('\n')
      return outputData
    }
  
    zip.file(`${fileName}${getDate}` + '.csv', inputData(data))
    zip.generateAsync({type:'blob'})
      .then(function(content) {
        saveAs(content, `${fileName}${getDate}` + '.zip')
      })
  }

  return {downloadZip}
}
